import { Unauthorized, NotFound } from "@app/shared/ErrorPages";
import { Roles, UserContext } from "@app/user";
import { JSX, useContext } from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import { TerminationsWizard } from "@app/terminations/import";
import ViewMyTerminations from "@app/terminations/ViewMyTerminations";
import { FeatureFlagContext, Features } from "@app/feature-flags";

const TerminationsRouter = (props: RouteComponentProps): JSX.Element => {
  const userContext = useContext(UserContext);
  const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;
  if (!userContext.roles.includes(Roles.VOLUME_TERMINATOR)) {
    return <Unauthorized />;
  }
  if (!featureFlags.has(Features.VOLUME_GHOST_PROVIDER_TERMINATIONS) && props.location.pathname == "/terminations/ghost") {
    return <NotFound />;
  }

  return (
    <Switch>
      <Route path={`${props.match.path}/view`} component={ViewMyTerminations} />
      <Redirect from={props.match.path} to={`${props.match.path}/view`} exact={true} />

      <Route path={`${props.match.path}/:terminationType`} render={(props: RouteComponentProps) => (
        <TerminationsWizard {...props} />
      ) } />
    </Switch>
  );
};

export default TerminationsRouter;
